
import { Vue, Component, Watch } from 'vue-property-decorator';
import { searchPostList } from '@/api/post';
import { getBoard } from '@/api/board';
import { getBoardCategory } from '@/api/boardCategory';
import { UserModule } from '@/store/user';
import { IPost, IBoard } from '@/types';
import Pagination from '@/components/board/pagination.vue';

@Component({
  name: 'GuideIndex',
  components: {
    Pagination,
  },
})
export default class extends Vue {
  private listQuery: any = {
    page: 0,
    size: 12,
    searchValue: '',
    sort: 'createDate,desc',
    progress: 0,
    categoryList1: '',
    categoryList2: '',
    boardUid: 'd74fbccf-2dc5-45e5-b7c0-5e323ae9e049',
  };

  private postList: IPost[] = [];

  private board: IBoard | null = null;

  private selectedCategoryList: any[] = [];

  private selectedCategoryList2: any[] = [];

  private category: any = { categoryName: '', children: [] };

  private category2: any = { categoryName: '', children: [] };

  private allCheck = true;

  private allCheck2 = true;

  private totalElements = 0;

  private totalPages = 1;

  private isInitLoad = true;

  @Watch('selectedCategoryList')
  onSelectedCategoryListChanged() {
    if (this.isInitLoad) return;
    this.handleSearch();
  }

  @Watch('selectedCategoryList2')
  onSelectedCategoryList2Changed() {
    if (this.isInitLoad) return;
    this.handleSearch();
  }

  mounted() {
    this.init();
  }

  private async init() {
    this.isInitLoad = true;

    await getBoard(this.listQuery.boardUid).then((res) => {
      this.board = res.data;
    }).catch(() => {
      alert('게시판 정보를 불러오는 데 실패했습니다:');
    });

    await getBoardCategory('33b34a3c-b79c-43bd-8042-e364d0f560da').then((res) => {
      this.category = res.data;
      this.selectedCategoryList = this.category.children.map((child: any) => child.uid);
    }).catch(() => {
      alert('첫 번째 카테고리를 불러오는 데 실패했습니다:');
    });

    await getBoardCategory('a46eb205-da98-4dd7-b90d-638915d5289d').then((res) => {
      this.category2 = res.data;
      this.selectedCategoryList2 = this.category2.children.map((child: any) => child.uid);
    }).catch(() => {
      alert('두 번째 카테고리를 불러오는 데 실패했습니다:');
    });
    // 2. 카테고리 정보를 다 가져왔으니, 이제 메모장(SessionStorage)을 확인합니다.
    const savedQuery = sessionStorage.getItem('guideListQuery');

    if (savedQuery) {
      // 메모가 있다면 메모장대로 변수들을 복원합니다.
      const parsedQuery = JSON.parse(savedQuery);
      this.listQuery = parsedQuery.listQuery;
      this.selectedCategoryList = parsedQuery.selectedCategoryList;
      this.selectedCategoryList2 = parsedQuery.selectedCategoryList2;
      sessionStorage.removeItem('guideListQuery');
    } else {
      // 메모가 없다면 (처음 들어온 거라면) 기본값인 전체 선택으로 채워줍니다.
      this.selectedCategoryList = this.category.children.map((child: any) => child.uid);
      this.selectedCategoryList2 = this.category2.children.map((child: any) => child.uid);
    }

    // 3. 복원된 상태(혹은 기본 상태)로 게시글 목록을 불러옵니다.
    this.searchPostList();

    // 4. 모든 데이터 세팅이 끝났으므로, 약간의 여유(0.1초)를 주고 깃발을 내립니다.
    // 이제부터 사용자가 마우스로 클릭하는 것은 정상적으로 Watch가 감지하게 됩니다!
    setTimeout(() => {
      this.isInitLoad = false;
    }, 100);
  }

  private searchPostList() {
    // const stateToSave = {
    //   listQuery: this.listQuery,
    //   selectedCategoryList: this.selectedCategoryList,
    //   selectedCategoryList2: this.selectedCategoryList2,
    // };
    // sessionStorage.setItem('guideListQuery', JSON.stringify(stateToSave));

    const apiQuery: any = { ...this.listQuery };

    if (this.selectedCategoryList.length > 0) {
      apiQuery.categoryList1 = this.selectedCategoryList.join(',');
    } else {
      delete apiQuery.categoryList1;
    }

    if (this.selectedCategoryList2.length > 0) {
      apiQuery.categoryList2 = this.selectedCategoryList2.join(',');
    } else {
      delete apiQuery.categoryList2;
    }

    const loading = this.$loading.show();
    searchPostList(apiQuery).then((res: any) => {
      this.postList = res.data.content;
      this.postList.forEach((post) => {
        if (post.categoryList && post.categoryList.length > 0) {
          post.categoryList.sort((a, b) => {
            const dateA = a.postCategoryPk.category.createDate;
            const dateB = b.postCategoryPk.category.createDate;
            return dateA.localeCompare(dateB);
          });
        }
      });

      this.totalElements = res.data.totalElements;
      this.totalPages = res.data.totalPages;
      loading.hide();
    }).catch((error) => {
      alert('API 요청 실패! 전체 오류:');
      loading.hide();
    });
  }

  private handleChangeAllCheck(e: any) {
    if (e.target.checked) {
      this.selectedCategoryList = this.category.children.map((c: any) => c.uid);
    } else {
      this.selectedCategoryList = [];
    }
  }

  private handleChangeAllCheck2(e: any) {
    if (e.target.checked) {
      this.selectedCategoryList2 = this.category2.children.map((c: any) => c.uid);
    } else {
      this.selectedCategoryList2 = [];
    }
  }

  private handleSearch() {
    this.listQuery.page = 0;
    this.searchPostList();
  }

  private handleChangePage(page: number) {
    this.listQuery.page = page;
    this.searchPostList();
  }

  private searchReset() {
    this.listQuery.searchValue = '';
    this.allCheck = true;
    this.allCheck2 = true;
    this.selectedCategoryList = this.category.children.map((c: any) => c.uid);
    this.selectedCategoryList2 = this.category2.children.map((c: any) => c.uid);
    this.handleSearch();
  }

  private getWriteAuth() {
    if (!this.board) {
      return false;
    }
    const boardRef = this.board;
    let hasWriteAuth = false;
    const userRoles = UserModule.roles;
    if (boardRef.authWrite === 'GUEST') return true;
    if (userRoles.indexOf('ROLE_ADMIN') > -1) return true;
    userRoles.forEach((role: string) => {
      if (boardRef.writeRoles.indexOf(role) > -1) hasWriteAuth = true;
    });
    return hasWriteAuth;
  }

  private formatChange(str: string) {
    if (str.length > 13) {
      return '-';
    }

    return str;
  }

  // 스크립트 영역에 함수 추가
  private handleClickPost(post: IPost) {
    // 1. 상세 페이지로 떠나기 직전에만 가방(sessionStorage)에 현재 상태를 싸둡니다!
    const stateToSave = {
      listQuery: this.listQuery,
      selectedCategoryList: this.selectedCategoryList,
      selectedCategoryList2: this.selectedCategoryList2,
    };
    sessionStorage.setItem('guideListQuery', JSON.stringify(stateToSave));

    // 2. 짐을 다 쌌으니, 상세 페이지로 이동합니다.
    this.$router.push({
      name: this.$route.name === 'AppBoard' ? 'AppPostDetail' : 'PostDetail',
      params: {
        menuUid: '21c4cbe5-321a-43c5-a426-cc9f9770a79e',
        postUid: post.uid,
      },
      query: { ...this.listQuery },
    });
  }
}
